var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},[_c('my-swiper'),_c('content01')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }